<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Usuários" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="card">
        <div class="card-body">
          <div class="card bg-light d-flex flex-fill">
            <div class="card-header border-bottom-0">
              <div class="row text-center">
                <div class="textos col-md-6"><span class="text-bold">Nome:</span> {{ formulario.f_name }} </div>
                <div class="textos col-md-6"><span class="text-bold">Login:</span> {{ formulario.f_username }} </div>
              </div>
            </div>
          </div>
          <b-alert v-model="flagsDeControle.avisoDeErroNoFormulario.exibir" variant="danger" fade dismissible>
            <span class="avisoDangerAlerta">{{flagsDeControle.avisoDeErroNoFormulario.mensagem}}</span>
          </b-alert>
          <div class="d-flex align-items-start align-items-sm-center align-items-xs-center  align-items-md-start flex-column flex-sm-column flex-xs-column flex-md-row flex-lg-row flex-xl-row">
            <nav class="nav nav-pills me-3 h-100 flex-md-column flex-lg-column flex-xl-column">
              <a class="nav-link active" id="vert-tabs-informacoes-tab" data-toggle="pill" href="#vert-tabs-informacoes" role="tab" aria-controls="vert-tabs-informacoes" aria-selected="true"><b>Informações</b> <i v-if="flagAbaInformacoes" class="fas fa-exclamation-triangle"></i></a>
              <a class="nav-link" id="vert-tabs-permissoes-tab" data-toggle="pill" href="#vert-tabs-permissoes" role="tab" aria-controls="vert-tabs-permissoes" aria-selected="false"><b>Permissões</b> <i v-if="flagAbaPermissoes" class="fas fa-exclamation-triangle"></i></a>
              <a class="nav-link" id="vert-tabs-perfil-tab" data-toggle="pill" href="#vert-tabs-perfil" role="tab" aria-controls="vert-tabs-perfil" aria-selected="false"><b>Perfil</b> <i v-if="flagAbaPerfil" class="fas fa-exclamation-triangle"></i></a>
              <a class="nav-link" id="vert-tabs-negociadores-tab" data-toggle="pill" href="#vert-tabs-negociadores" role="tab" aria-controls="vert-tabs-negociadores" aria-selected="false"><b>Negociadores</b> <i v-if="flagAbaNegociadores" class="fas fa-exclamation-triangle"></i></a>
            </nav>
            <div class="tab-content w-100 " id="vert-tabs-tabContent">
              <div class="tab-pane fade active show" id="vert-tabs-informacoes" role="tabpanel" aria-labelledby="vert-tabs-informacoes-tab">
                <div class="card">
                  <div class="card-body">
                    <Informacoes :fotoUsuario="f_photo_usuario">
                      <template #senha>
                        <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                          <div class="form-group">
                            <label for="inputNovaSenha">Senha</label>
                            <input type="password" name="f_password" v-model="formulario.f_password" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" autocomplete="new-password" class="form-control" id="inputNovaSenha">
                            <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_password}}</div>
                          </div>
                        </div>
                      </template>
                      <template #confirmacao-senha>
                        <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                          <div class="form-group">
                            <label for="inputConfirmarSenha">Confirmar Senha</label>
                            <input type="password" name="confirmar-senha" v-model="formulario.f_password_confirm" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" autocomplete="off" class="form-control" id="inputConfirmarSenha">
                            <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_password_confirm}}</div>
                          </div>
                        </div>
                      </template>
                    </Informacoes>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="vert-tabs-permissoes" role="tabpanel" aria-labelledby="vert-tabs-permissoes-tab">
                <Permissoes />
              </div>
              <div class="tab-pane fade" id="vert-tabs-perfil" role="tabpanel" aria-labelledby="vert-tabs-perfil-tab">
                <Perfil />
              </div>
              <div class="tab-pane fade" id="vert-tabs-negociadores" role="tabpanel" aria-labelledby="vert-tabs-negociadores-tab">
                <Negociadores />
              </div>
            </div>
          </div>
        </div> <!-- ./ card-body ends-->
        <div class="card-footer text-right">
          <div class="row btn-group btn-group-justified" role="group">
            <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="salvarRegistro()">Salvar</b-button></div>
            <router-link class="" to="/usuarios">
              <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Cancelar</b-button>
            </router-link>
          </div>
        </div>
      </div> <!-- ./ card ends-->
    </section> <!-- ./ content -->
  </div> <!-- /.content-wrapper -->
</div> <!-- ./wrapper -->
</template>

<script>
import EdicaoUsuarioAdministracao from './js/edicao-usuario-administracao'
export default EdicaoUsuarioAdministracao
</script>

<style scoped>
@import "./scss/informacoes.scss";
</style>
